<template>
  <div class="suggestion-banner bg-white flex j_center wc" :class="{bg_gray: bg_gray}" v-if="$store.state.main.show_suggestion_banner_search">
      <div class="container">

      
      <div class="suggestion-banner__inner br-12 bg-gray flex j_sb">
          <div class="suggestion-banner__text-box">
              <h2 class="f-38 bold uppercase">{{content.title}}</h2>
              <h3 class="f-18 bold" v-if="windowWidth >= 1366">{{content.teaser}}</h3>
                    <router-link :to="content.link" class="suggestion-banner__cta button f-white f-14 bold bg-light-purple uppercase">
                <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="11.352" height="11.351" viewBox="0 0 11.352 11.351">
                <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z" fill="#fff"/>
                </svg>
                            {{content.link_name}}
                 </router-link>
            </div>

        <picture  class="br-12">
      
        <source media="(max-width: 1365px)" :srcset="content.images[0].devices.tablet">
        <source media="(max-width: 767px)" :srcset="content.images[0].devices.mobile">
       
         <img :src="content.images[0].devices.desktop" alt="" class="suggestion-banner__img cover" data-scroll data-scroll-speed="-1">
        </picture> 

      </div>
</div>
  </div>
</template>

<script>
import resize_handler from '@/mixins/resize_handler';
export default {
mixins: [resize_handler],
 props: ['contentData'],
 computed: {
     content(){
         return _.get(this.contentData, 'data.list[0]');
     },
     bg_gray(){
         return _.get(this.contentData, 'conf.conf').includes('bg_gray');
     }
 },
}
</script>

